/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { GooglePayOrderRequestViewModel } from "../types/GooglePayOrderRequestViewModel.ts";
import { googlePayIntermediateSigningKeyViewModelSchema } from "./googlePayIntermediateSigningKeyViewModelSchema.ts";

export const googlePayOrderRequestViewModelSchema = z.object({
  installments: z.optional(z.number().int()),
  statementDescriptor: z.string().nullish(),
  merchantIdentifier: z.string().nullish(),
  version: z.string().nullish(),
  signature: z.string().nullish(),
  intermediateSigningKey: z.optional(
    z.lazy(() => googlePayIntermediateSigningKeyViewModelSchema),
  ),
  signedMessage: z.string().nullish(),
}) as unknown as ToZod<GooglePayOrderRequestViewModel>;
